/**
 * How many placeholders a skeleton renders for a consumer-supplied count (TO-650, REQ-017).
 * Fractions round down and anything below one renders one, because a loading state is never blank
 * (ux-interaction-standards §1). A missing or non-finite count falls back to the layout default.
 */
export function placeholderCount(requested: number | undefined, fallback: number): number {
	const count = requested !== undefined && Number.isFinite(requested) ? requested : fallback
	return Math.max(1, Math.floor(count))
}

/** `[0, 1, …, count - 1]`, used as stable keys for fixed-length, never-reordered placeholders. */
export function placeholderKeys(count: number): number[] {
	return Array.from({ length: count }, (_, index) => index)
}
